export { default as CardLabel } from "./CardLabel";
